import { Component, OnInit } from '@angular/core';
import { ConfigService } from './config.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { PlatformService } from './platform.service';
import { ScriptLoaderService } from './scripts-loader-service';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    router: Router,
    private configService: ConfigService,
    private platform: PlatformService,
    private scriptLoader: ScriptLoaderService,
  ) {
    const navEndEvent$ = router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
    );
    if (this.platform.isBrowserPlatform()) {
      navEndEvent$.subscribe((e: NavigationEnd) => {
        gtag('config', this.configService.getConfig().googleAnalyticsTag, {
          page_path: e.urlAfterRedirects,
        });
      });
    }

    if (this.platform.isBrowserPlatform()) {
      const platformdocument = this.platform.getDocument();
      if (platformdocument) {
        const headerScript = platformdocument.createElement('script');
        headerScript.async = true;
        headerScript.src =
          'https://www.googletagmanager.com/gtag/js?id=' +
          this.configService.getConfig().googleAnalyticsTag;
        platformdocument.head.prepend(headerScript);
      } else {
        console.warn('Document is not available in SSR context');
      }
    }
  }
  async ngOnInit(): Promise<void> {
    if (this.platform.isBrowserPlatform()) {
      await this.scriptLoader.loadScript('https://cdn.jsdelivr.net/npm/babel-polyfill/dist/polyfill.min.js');
      await this.scriptLoader.loadScript('https://cdn.jsdelivr.net/npm/@webcomponents/webcomponentsjs/webcomponents-lite.js');
      await this.scriptLoader.loadScript('https://cdn.jsdelivr.net/npm/@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js');
      await this.scriptLoader.loadScript('https://www.ebi.ac.uk/pdbe/pdb-component-library/js/protvista-pdb-3.3.0.js');
    }
  }
}
